import type { Ref } from 'react';
import { HtmlRenderer as CoreHtmlRenderer } from '@eliadmin/core/src/components/ui/html-renderer';
import { cn } from '@eliadmin/core/src/utils/style-utils';
export { rewriteHtmlImageSources } from '@eliadmin/core/src/utils/html-image-sources';

type HtmlRendererProps = {
  html: string;
  forcedTextSize?: string;
  className?: string;
  refDiv?: Ref<HTMLDivElement>;
  variant?: 'default' | 'description';
  size?: 'sm' | 'base';
  color?: 'white' | 'foreground' | 'muted-foreground' | 'light-gray';
};

// Tenant typography only. Sanitization/embeds/CDN images and its browser
// split are inherited from the installed core, never duplicated or bypassed.
export function HtmlRenderer({
  html,
  forcedTextSize,
  className,
  refDiv,
  variant = 'default',
  size = 'base',
  color = 'foreground',
}: HtmlRendererProps) {
  const rootClassName = cn(
    'ea-html-renderer',
    forcedTextSize,
    className,
    variant === 'description' && 'ea-html-description',
    variant === 'description' && size === 'sm' && 'ea-html-description--sm',
    variant === 'description' && size === 'base' && 'ea-html-description--base',
    variant === 'description' && color === 'white' && 'text-white',
    variant === 'description' && color === 'light-gray' && 'text-[#969696]',
    variant === 'description' && color === 'foreground' && 'text-foreground',
    variant === 'description' && color === 'muted-foreground' && 'text-muted-foreground',
  );
  if (!html) return <div ref={refDiv} className={rootClassName} />;
  return <CoreHtmlRenderer html={html} className={rootClassName} refDiv={refDiv} />;
}
